export default function initNaviDrawer() {
  document.querySelectorAll("[data-navi-drawer]").forEach(function (item) {
    item.addEventListener("click", () => {
      const menu = document.getElementById(
        item.attributes["data-navi-drawer"].value
      );

      if (menu.className.indexOf("navi-drawer--open") === -1) {
        menu.className += " navi-drawer--open";
        document.body.parentNode.classList.add("scroll-fixed");
      } else {
        menu.className = menu.className.replaceAll("navi-drawer--open", "");
        document.body.parentNode.classList.remove("scroll-fixed");
      }
    });
  });

  document.querySelectorAll("[data-submenu]").forEach(function (submenu) {
    const name = submenu.attributes["data-submenu"].value;
    const link = submenu.querySelector(`[data-submenu-link="${name}"`);

    link.addEventListener("click", () => {
      if (submenu.className.indexOf("open") === -1) {
        submenu.className += " open";
      } else {
        submenu.className = submenu.className.replaceAll("open", "");
      }
    });
  });
}
